import {BaseElement} from "./baseElement.ts";
import {Box} from "../layout/box.ts";
import type {jsPDF} from "jspdf";

export class FlexContainer extends BaseElement {
	gapX: number;
	align: string;

	constructor(box: Box, id: string, gapX: number, align = "top") {
		super(box, id);
		this.gapX = gapX;
		this.align = align;
	}

	async calculate(jsPdf: jsPDF) {
		const boundingBox = this.box.getBoundingBox();
		let rowHeight = 0;
		let cursorX = boundingBox.x;
		let totalHeight = 0;
		for (const child of this.children) {
			child.box.position.x = cursorX;
			child.box.position.y = boundingBox.y;
			await child.calculate(jsPdf);
			const childBoundingBox = child.box.getBoundingBox();
			rowHeight = Math.max(rowHeight, childBoundingBox.outerHeight);
			cursorX += childBoundingBox.outerWidth + this.gapX;
		}

		totalHeight = Math.max(totalHeight, rowHeight);
		this.box.size.height = totalHeight;

		if (this.align == "center") {
			const center = this.box.size.height / 2;
			for (const child of this.children) {
				const childBoundingBox = child.box.getBoundingBox();
				child.box.position.y = childBoundingBox.y + center - childBoundingBox.outerHeight / 2;
				await child.calculate(jsPdf);
			}
		}
	}

	override async draw(pdfDocument: jsPDF): Promise<void> {
		for (const child of this.children) {
			await child.draw(pdfDocument);
		}
	}
}
